import React from 'react'

export default ({width, height}) => (
  <svg className="shape shape--arrow" width={width} height={height} viewBox="0 0 24 24">
    <path d='M11,16.5857864 L11,3.9999602 C11,3.44769743 11.4438648,3 12,3 C12.5522847,3 13,3.45470893 13,3.9999602 L13,16.6568542 L15.9518475,13.7050068 C16.3365092,13.320345 16.9734367,13.3165825 17.363961,13.7071068 C17.757208,14.1003537 17.7554255,14.7298558 17.366061,15.1192203 L13.1192203,19.366061 C13.0316746,19.4536067 12.9310621,19.5214227 12.8232614,19.5693511 C12.6434885,19.8295905 12.3431113,20 12,20 C11.6379832,20 11.3208964,19.8046269 11.1453838,19.5164452 C11.0761153,19.4753566 11.0109988,19.4252123 10.9518475,19.366061 L6.70500677,15.1192203 C6.31564228,14.7298558 6.31385983,14.1003537 6.70710678,13.7071068 C7.09763107,13.3165825 7.73455861,13.320345 8.11922033,13.7050068 L11,16.5857864 Z'></path>
  </svg>
)


// WEBPACK FOOTER //
// ./src/components/Shapes/Arrow.js